<template>
  <div class="headline primary--text">{{title}}</div>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "PageTitle",
    props: ["title"]
  }
</script>

<style scoped>

</style>